// themeContext.js
import React, { createContext, useContext } from 'react';
import useThemeMode from './useThemeMode';
 
// Create a context to hold theme controls from useThemeMode
const ThemeContext = createContext(null);
 
export const ThemeProvider = ({ children }) => {
  // useThemeMode handles reading/writing localStorage, applying body class,
  // and reacting to system preference changes
  const themeControls = useThemeMode();
 
  return (
    <ThemeContext.Provider value={themeControls}>
      {children}
    </ThemeContext.Provider>
  );
};
 
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context; // returns { theme, enable, disable, toggle, isDark }
};
 